function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { BOS, HALIFAX, LLOYDS, LLOYDS2023, MBNA, SCOTTISH_WIDOWS, WHITE_LABEL_DARK, WHITE_LABEL_LIGHT } from "../../constants";
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.5 3.5h-4.834L12.5 13.377 5.334 3.5H.5l11.954 17z",
    fillRule: "evenodd"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "21.999023 6.58578644 23.4132366 8 11.9995115 19.4137251 0.585786438 8 2 6.58578644 11.999 16.585"
  })));
};
HalifaxIcon.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.92 4L12 12 4.08 4 0 7.879 12 20 24 7.879z",
    fillRule: "evenodd"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsIcon = function LloydsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23.5757 7.53227L12.0073 19L0.43888 7.53227C-0.146293 6.95219 -0.146293 6.01514 0.43888 5.43506C1.02405 4.85498 1.96933 4.85498 2.55451 5.43506L11.9923 14.7907L21.4301 5.43506C22.0153 4.85498 22.9605 4.85498 23.5457 5.43506C24.1373 6.02151 24.1551 6.92776 23.5757 7.53227Z",
    fill: "currentColor"
  }));
};
LloydsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MaterialIcon = function MaterialIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.9985 19L0 7.44428L1.5 6L12 16.11L22.5 6.00001L24 7.44431L11.9985 19Z",
    fill: "currentColor"
  }));
};
MaterialIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    transform: "translate(12.000000, 12.000000) rotate(90.000000) translate(-12.000000, -12.000000) ",
    d: "M14.494369,11.9966749 L5.86442259,20.9677835 C5.21338576,21.6445573 5.20679298,22.7770827 5.87595995,23.4727034 C6.54842331,24.1734641 7.62304612,24.1734641 8.28562031,23.4864102 L17.9357991,13.4547371 C18.3049947,13.069233 18.4665178,12.538094 18.4154237,12.0223752 C18.4846479,11.4946629 18.324773,10.9429638 17.9357991,10.5403262 L8.28562031,0.508653036 C7.63458349,-0.168120813 6.54512692,-0.174974219 5.87595995,0.520646496 C5.2018484,1.21969391 5.2018484,2.3367991 5.86442259,3.02556641 L14.494369,11.9966749 Z"
  }));
};
MbnaIcon.defaultProps = {
  fill: "currentColor",
  fillRule: "evenodd",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5645 5.4323C24.1452 6.00871 24.1452 6.94324 23.5645 7.51964L12 19L0.435472 7.51964C-0.145157 6.94324 -0.145157 6.00871 0.435472 5.4323C1.0161 4.8559 1.95748 4.8559 2.53811 5.4323L12 14.8253L21.4619 5.4323C22.0425 4.8559 22.9839 4.8559 23.5645 5.4323Z",
    fill: "currentColor"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import React from 'react';
import { ThemeContext } from 'styled-components';
export default function (_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = React.useContext(ThemeContext) || {};
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.chevron_down) {
    var _theme$assets2, _theme$assets2$icons;
    svg = (_theme$assets2 = theme.assets) === null || _theme$assets2 === void 0 ? void 0 : (_theme$assets2$icons = _theme$assets2.icons) === null || _theme$assets2$icons === void 0 ? void 0 : _theme$assets2$icons.chevron_down;
  } else {
    switch (brand) {
      case LLOYDS:
        svg = LloydsIcon;
        break;
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS2023:
        svg = Lloyds2023Icon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      case WHITE_LABEL_DARK:
      case WHITE_LABEL_LIGHT:
        svg = MaterialIcon;
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn("Icon is not available in brand \"".concat(brand, "\"."));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}